module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-2-10.f83c917b.png";